import { observable } from "mobx";
import { RacingEventInfo, RacingResultInfo } from "../";
/**
* RacingMasterEventInfo defines model for branch object information
*
* @typedef RacingMasterEventInfo
* @type {Object}
* @property {string} RacingMasterEventInfo.id identifier
* @property {name} Name of racing event info master event
* @property {date} Date of racing event info master event
* @property {raceProgress} RacingEvents of racing event info master event
*/

export class RacingMasterEventInfo {
    id: string;
    date: Date;
    masterLeagueId: string;
    @observable raceProgress: number;
    @observable racingEvents: RacingEventInfo[];
    @observable hasLiveStream!: boolean;
    @observable racingResult?: RacingResultInfo;
    url: string;

    constructor(data: RacingMasterEventInfo) {
        this.id = data.id;
        this.date = data.date;
        this.racingEvents = data.racingEvents;
        this.masterLeagueId = data.masterLeagueId;
        this.raceProgress = data.raceProgress
        this.url = data.url;
    }
}
